import { Input, Label } from '@nimbus-ds/components';
import { useEffect, useState, type ReactElement } from 'react';
import { aCentavos, deCentavos } from '../formato';

interface Props {
  readonly id: string;
  readonly etiqueta: string;
  readonly placeholder?: string;
  /** Valor del modelo, en centavos. `null` es "vacío". */
  readonly valor: number | null;
  readonly onValor: (centavos: number | null) => void;
}

/**
 * Campo de importe en pesos, controlado.
 *
 * *** El bug que arregla: los campos de precio tenían `onChange` sin `value`. *** El
 * modelo guardaba el importe y el input se dibujaba vacío al volver a montarse —o sea al
 * ir "Atrás" en el wizard—, así que el comerciante creía haber borrado un filtro de
 * precio que seguía aplicándose. En una app de precios, que lo mostrado no coincida con
 * lo que se manda no es un detalle.
 *
 * El texto vive acá y no en el padre porque el modelo son centavos: si se derivara el
 * texto del número en cada tecla, escribir "1" mostraría "0,01" y escribir "12," sería
 * imposible. El estado externo sólo pisa el texto cuando **deja de representarlo**, que
 * es exactamente el caso de volver atrás o de un reinicio del formulario.
 */
export function EntradaDePesos({ id, etiqueta, placeholder, valor, onValor }: Props): ReactElement {
  const [texto, setTexto] = useState<string>(() => deCentavos(valor));

  useEffect(() => {
    setTexto((actual) => (aCentavos(actual) === valor ? actual : deCentavos(valor)));
  }, [valor]);

  return (
    <>
      <Label htmlFor={id}>{etiqueta}</Label>
      <Input
        id={id}
        name={id}
        inputMode="decimal"
        {...(placeholder === undefined ? {} : { placeholder })}
        value={texto}
        onChange={(evento) => {
          const escrito = evento.currentTarget.value;
          setTexto(escrito);
          onValor(aCentavos(escrito));
        }}
      />
    </>
  );
}
